<template>
  <Steps @changeStepClicked="changeStepClicked" />
  <DetailsProject v-if="currentStep === 1" :projectId="projectId" />
  <CollaboratorsProject v-if="currentStep === 2" :projectId="projectId" />
  <BiddersProject v-if="currentStep === 3" :projectId="projectId" />
  <PartnersProject v-if="currentStep === 4" :projectId="projectId" />
  <StepsProject v-if="currentStep === 5" :projectId="projectId" />
  <ResultsProject v-if="currentStep === 6" :projectId="projectId" />
  <TeamsProject v-if="currentStep === 7" :projectId="projectId" />
  <TimelineProject v-if="currentStep === 8" :projectId="projectId" />
  <FinancialResourcesProject v-if="currentStep === 9" :projectId="projectId" />
  <CommitteeProject v-if="currentStep === 10" :projectId="projectId" />
</template>

<script>
import Steps from '@/components/projects/Steps.vue'
import DetailsProject from '@/components/projects/projects/DetailsProject.vue'
import CollaboratorsProject from '@/components/projects/collaborators/CollaboratorsProject.vue'
import BiddersProject from '@/components/projects/bidders/BiddersProject.vue'
import PartnersProject from '@/components/projects/partners/PartnersProject.vue'
import StepsProject from '@/components/projects/steps/StepsProject.vue'
import ResultsProject from '@/components/projects/results/ResultsProject.vue'
import TeamsProject from '@/components/projects/teams/TeamsProject.vue'
import TimelineProject from '@/components/projects/timeline/TimelineProject.vue'
import FinancialResourcesProject from '@/components/projects/financialResources/FinancialResourcesProject.vue'
import CommitteeProject from '@/components/projects/committee/CommitteeProject.vue'

export default {
  name: 'ProjectDetails',

  components: {
    Steps,
    DetailsProject,
    CollaboratorsProject,
    BiddersProject,
    PartnersProject,
    StepsProject,
    ResultsProject,
    TeamsProject,
    TimelineProject,
    FinancialResourcesProject,
    CommitteeProject,
  },

  data() {
    return {
      projectId: this.$route.params.projectId,
      currentStep: 1,
    }
  },

  methods: {
    changeStepClicked(stepClicked) {
      this.currentStep = stepClicked
    },
  },
}
</script>
